import BaseApi from './baseApi';
import IInbound from '../models/IInbound';
import IAuthentication from '../models/IAuthentication';
export default class InboundApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInbounds(idCompany: string) : Promise<IInbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsSubstractMonth(idCompany: string) : Promise<IInbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompanyAndDate(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsCompleted(idCompany: string) : Promise<IInbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsPlanning(idCompany: string) : Promise<IInbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsForDossier(idCompany: string) : Promise<IInbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompanyWithCompletedInbounds(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsByCustomer(idCustomer : string) : Promise<IInbound[]> {
        let json : string = this.getJsonReadWithIdCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsFromToday(idCompany: string) : Promise<IInbound[]> {
        let json : string = this.getJsonReadWithIdCompanyFromToday(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsCodes(idCompany: string) : Promise<IInbound[]> {
        let json : string = this.getJsonReadCodes(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInbound(inbound: IInbound) : Promise<string> {
        const json = this.getJsonSave(inbound);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInbound(inbound: IInbound) : Promise<boolean> {
        const json = this.getJsonUpdate(inbound);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInbound(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async GetInboundsByDate(time: string) : Promise<IInbound[]> {
        let json : string = this.getJsonReadByTimeSlot(time);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inbounds: IInbound[] = [];
            inbounds = response.data as IInbound[];
            return inbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "Inbounds"
        };
        return json;
    }

    private getJsonSave(inbound: IInbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": inbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": inbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": inbound.idCustomer
            }, {
                "Item1": "idStatus",
                "Item2": inbound.idStatus
            }, {
                "Item1": "code",
                "Item2": inbound.code
            }, {
                "Item1": "dateIn",
                "Item2": inbound.dateIn
            }, {
                "Item1": "description",
                "Item2": inbound.description
            }, {
                "Item1": "containerNumber",
                "Item2": inbound.containerNumber
            }, {
                "Item1": "sealNumber",
                "Item2": inbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": inbound.weight
            }, {
                "Item1": "GRNNumber",
                "Item2": inbound.grnNumber
            }, {
                "Item1": "ReferenceInboundCode",
                "Item2": inbound.referenceInboundCode
            }, {
                "Item1": "OrderNumber",
                "Item2": inbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": inbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": inbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": inbound.dateChanged
            }, {
                "Item1": "entrepot",
                "Item2": inbound.entrepot
            }, {
                "Item1": "agp",
                "Item2": inbound.agp
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Inbounds"
        };
        return json;
    }

    private getJsonUpdate(inbound: IInbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": inbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": inbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": inbound.idCustomer
            }, {
                "Item1": "idStatus",
                "Item2": inbound.idStatus
            }, {
                "Item1": "code",
                "Item2": inbound.code
            }, {
                "Item1": "dateIn",
                "Item2": inbound.dateIn
            }, {
                "Item1": "description",
                "Item2": inbound.description
            }, {
                "Item1": "containerNumber",
                "Item2": inbound.containerNumber
            }, {
                "Item1": "sealNumber",
                "Item2": inbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": inbound.weight
            }, {
                "Item1": "GRNNumber",
                "Item2": inbound.grnNumber
            }, {
                "Item1": "ReferenceInboundCode",
                "Item2": inbound.referenceInboundCode
            }, {
                "Item1": "OrderNumber",
                "Item2": inbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": inbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": inbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": inbound.dateChanged
            }, {
                "Item1": "entrepot",
                "Item2": inbound.entrepot
            }, {
                "Item1": "agp",
                "Item2": inbound.agp
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Inbounds",
            "keyvalue": inbound.id
        };
        return json;
    }

    private getJsonReadByTimeSlot(time: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn",
                "Item3": "=",
                "Item4": time
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusInbounds WHERE Name = 'Completed')"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCustomer
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusInbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadCodes(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "Id",
                "Item3": "IN",
                "Item4": "(SELECT IdInbound FROM InboundsDeliveryNotes WHERE IdWarehouse IN (SELECT IdWarehouse FROM WarehousesShared WHERE idWarehouse = InboundsDeliveryNotes.IdWarehouse) AND Deleted = 0)",
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyWithCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyAndDate(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn",
                "Item3": ">",
                "Item4": this.subtractMonths(1),
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private subtractMonths(numOfMonths: number, date = new Date()) {
        date.setMonth(date.getMonth() - numOfMonths);
        return date;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus",
                "Item3": "IN",
                "Item4": "(SELECT ID FROM ListStatusInbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyWithCompletedInbounds(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyFromToday(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusInbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "description"
            }, {
                "Item1": "Inbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "weight"
            }, {
                "Item1": "Inbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Inbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Inbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Inbounds",
                "Item2": "agp"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn",
                "Item3": ">=",
                "Item4": new Date(),
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
